// Dev-only localStorage sign-in shim used when no VITE_OIDC_AUTHORITY is
// configured. Lives outside app.tsx so SignedOutPage does not import the
// route tree (avoids an app.tsx <-> signed-out-page.tsx import cycle).
const DEV_SIGNED_IN_KEY = "thrive_dev_signed_in";

export function localDevSignedIn(): boolean {
  try {
    return localStorage.getItem(DEV_SIGNED_IN_KEY) === "true";
  } catch {
    return false;
  }
}

export function setLocalDevSignedIn(value: boolean): void {
  try {
    if (value) localStorage.setItem(DEV_SIGNED_IN_KEY, "true");
    else localStorage.removeItem(DEV_SIGNED_IN_KEY);
  } catch {
    /* ignore */
  }
}
